import { AxiosInstance } from 'axios';

import { BaseAuthenticatedClient } from '.';
import { BaseDataResponse, BaseResponse } from '../responses';
import { StateModel } from '../interfaces';
import { IAuthenticatedRequestHandler, IErrorHandler } from '../abstractions';

export default class StateClient extends BaseAuthenticatedClient {
  constructor(authenticatedRequestHandler: IAuthenticatedRequestHandler, errorHandler: IErrorHandler, axiosInstance: AxiosInstance) {
    super(authenticatedRequestHandler, errorHandler, axiosInstance, 'state');
  }

  public async getAllAsync(): Promise<BaseDataResponse<StateModel[]>> {
    return await this.getHttpAsync<BaseDataResponse<StateModel[]>>('', '');
  }

  public async createAsync(model: StateModel): Promise<BaseDataResponse<StateModel>> {
    return await this.postHttpAsync<BaseDataResponse<StateModel>, StateModel>('', model);
  }

  public async updateAsync(model: StateModel): Promise<BaseDataResponse<StateModel>> {
    return await this.putHttpAsync<BaseDataResponse<StateModel>, StateModel>(`${model.id}`, model);
  }

  public async deleteAsync(id: number): Promise<BaseResponse> {
    return await this.deleteHttpAsync<BaseResponse>(`${id}`);
  }
}
